import { Component, inject } from '@angular/core';
import { LicenseManager } from 'ag-grid-enterprise';
import { environment } from '../environments/environment';
import { InsightService } from './services/rum-service/insight.service';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'tdf-root',
  // AppComponent is declared in AppModule (NgModule bootstrap), so it cannot be standalone.
  // eslint-disable-next-line @angular-eslint/prefer-standalone
  standalone: false,
  template: '<router-outlet></router-outlet>',
})
export class AppComponent {
  private readonly insight = inject(InsightService);
  private readonly router = inject(Router);

  constructor() {
    if (environment?.agGridLicenseKey)
      LicenseManager.setLicenseKey(environment.agGridLicenseKey);

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.insight.recordPageView(event.url);
      }
    });
  }
}
